import axios from "axios";
import apiPath from "../constants/apiPath";
import { useContext, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";

const client = axios.create({
  baseURL: apiPath.baseURL,
});

const useRequest = () => {
  const { logout } = useContext(AuthContext);

  const request = useCallback(
    async ({
      url,
      method: tmethod,
      data,
      onSuccess,
      onError,
      header,
      onErrorSubmit,
    }) => {
      if (!url) {
        console.warn("useRequest skipped: url is undefined or empty");
        return;
      }
      const method = tmethod.trim().toUpperCase();
      let token = localStorage.getItem("token")
        ? localStorage.getItem("token")
        : "";

      const headers = {
        ...header,
        Authorization: `Bearer ${token}`,
      };

      try {
        const response = await client({
          url,
          method,
          data,
          headers: { ...headers },
        });

        if (onSuccess) {
          onSuccess(response.data);
        } else {
          onErrorSubmit(response.data);
        }
        return response.data;
      } catch (err) {
        if (err.code === "ERR_NETWORK") {
          console.log("Network Error");
        }
        if (err.status === 401) {
          logout();
        } else if (err.response?.data?.message === "jwt expired") {
          logout();
        } else if (onError) {
          onError(err);
        }
      }
    },
    [logout]
  );

  return { request };
};

export default useRequest;
